import type { FeatureZoomOverride } from "./featureZoomOverrideTypes";

// Per-part zoom overrides for visualizerType "LaundryRoom" — see the shape/unit docs in
// ../featureGroupZoomDefaults.ts (getFeatureZoomOverride). Bulk-ported (2026-08-15) from
// scss/bv/responsive-canvas-laundryRoom.scss's per-part `scale(X)` values.
export function getLaundryRoomFeatureZoomOverride(partId: string): FeatureZoomOverride | undefined {
  switch (partId) {
    // 2026-08-22: these used to be excluded from zooming altogether by
    // useZoomToActiveFeatureGroup.ts's old shouldZoomPartId(partId, isMobile) gate — walls/floors
    // always, cabinets/countertops/edges on desktop only. That gate is gone, so they're pinned to
    // scale: 1 here instead (no visual zoom-in, same net effect as before, but going through the
    // normal per-part override path instead of a separate boolean gate). This also pulls
    // "countertop" out of its old scale: 1.3 case below.
    case "top_cabinet":
    case "bottom_cabinet":
    case "center_island_cabinet":
    case "fridge_enclosure":
    case "tall_cabinet":
    case "countertop":
    case "center_island_countertop":
    case "backsplash":
    case "edge":
    case "edge_profile":
    case "center_island_edge":
    case "kitchen_floor":
    case "left_wall":
    case "right_wall":
    case "front_wall":
    case "back_wall":
    case "split_wall":
    case "left_wall_splitter":
    case "bathroom_floor":
    case "shower_floor":
    case "shower_curb":
    case "shower_pan_combo":
      return { scale: 1 };
    default:
      return undefined;
  }
}
